const checkSlot = (slot, allowedSlotElements, disallowedSlotElements) => {
    const allowedElements = (allowedSlotElements === null || allowedSlotElements === void 0 ? void 0 : allowedSlotElements[slot.name]) || [];
    const disallowedElements = (disallowedSlotElements === null || disallowedSlotElements === void 0 ? void 0 : disallowedSlotElements[slot.name]) || [];
    if (allowedElements.length === 0 && disallowedElements.length === 0) {
        return;
    }
    const nodes = slot.assignedNodes();
    nodes.forEach((node) => {
        const name = node.nodeName.toLowerCase();
        if ((allowedElements.length > 0 && !allowedElements.includes(name)) || disallowedElements.includes(name)) {
            node.parentElement.removeChild(node);
            // eslint-disable-next-line no-console
            console.error(`Element <${name}> is not allowed in slot "${slot.name}". It has been removed.`);
        }
    });
};
/**
 * Limits the kind of elements that can be inserted into a (named) slot of a web component.
 * Illegal elements are removed from the DOM.
 * This function must be called in componentDidLoad method of the web component.
 * It only works with shadow DOM.
 * @param host The host element of the component.
 * @param allowedSlotElements An object that defines the allowed element-names (in lowercase) for each slot.
 * */
export const limitSlotElements = (host, options) => {
    const slots = host.shadowRoot.querySelectorAll("slot");
    slots.forEach((slot) => {
        checkSlot(slot, options.allowed, options.disallowed);
        slot.addEventListener("slotchange", () => {
            checkSlot(slot, options.allowed, options.disallowed);
        });
    });
};
//# sourceMappingURL=limitSlotElements.js.map
